import _ from 'lodash';
import { TextAsset } from '../../../../../../../types';
import { Views } from '../../../../../../../constants';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useHighlightTextAsset = (textAsset: TextAsset) => {
  const store = useCreativeTemplatesBuilderStore();
  if (store.view === Views.ImageOrVideoCreativeTemplateEditor) return {};

  const activeCarousel = _.find(store.carousels, { id: store.activeCarouselId });
  const activeSlide = activeCarousel && _.find(activeCarousel.carouselAssetSpecs, { id: store.activeSlideId });

  const textAssets = [activeCarousel?.message, activeSlide?.textAssets?.headline, activeSlide?.textAssets?.description];

  const activeTextAsset = _.find(_.compact(_.uniqBy(textAssets, 'id')), { id: textAsset.id });

  return { activeTextAsset };
};
